<template>
  <div>
    <el-row>
      <el-col :span="16">
        <el-card style="margin-right: 5px">
          <div class="clearfix" slot="header">
            <span style="float:left; font-weight: 800">个人信息</span>
          </div>
          <el-form :model="info">
            <el-form-item label="邮箱">
              <el-input v-model="info.email" disabled></el-input>
            </el-form-item>
            <el-form-item label="用户名">
              <el-input v-model="info.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="昵称">
              <el-input v-model="info.nickName"></el-input>
            </el-form-item>
            <el-form-item label="电话">
              <el-input v-model="info.phoneNumber"></el-input>
            </el-form-item>
            <el-form-item label="IM">
              <el-input v-model="info.im"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="float: right" @click="update_info">确认</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card style="margin-left: 5px">
          <div class="clearfix" slot="header">
            <span style="float:left; font-weight: 800">修改密码</span>
          </div>
          <el-form :model="form" ref="form" :rules="rules">
            <el-form-item label="旧密码" prop="old_password">
              <el-input v-model="form.old_password" type="password"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="new_password">
              <el-input v-model="form.new_password" type="password"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="new_password_confirm">
              <el-input v-model="form.new_password_confirm" type="password"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="float: right" @click="change_password">确认</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (this.form.new_password_confirm !== "") {
          this.$refs.form.validateField("new_password_confirm");
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.form.new_password) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      info: {},
      form: {
        old_password: "",
        new_password: "",
        new_password_confirm: "",
        change_password: true,
        token: "",
      },
      rules: {
        old_password: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
        ],
        new_password: [{ validator: validatePass, trigger: "change" }],
        new_password_confirm: [{ validator: validatePass2, trigger: "change" }],
      },
    };
  },
  created() {
    this.info = this.config.getLoginInfo().data;
  },
  methods: {
    change_password() {
      const _this = this;
      _this.form.token = _this.config.getCookie();
      _this.$axios
        .put(_this.config.path + "/auth/change-password", _this.form, {
          headers: {
            Authorization: "Bearer " + _this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === true) {
            _this.$message({
              showClose: true,
              message: "创建用户成功",
              type: "success",
            });
            setTimeout(function () {
              _this.$router.go(0);
            }, 500);
          } else {
            _this.$message({
              showClose: true,
              message: "修改密码失败: " + res.data.message,
              type: "error",
            });
          }
        })
        .catch(function (err) {
          _this.$message({
            showClose: true,
            message: "修改密码失败: " + err.toString(),
            type: "error",
          });
        });
    },
    update_info() {
      const _this = this;
      console.log("user: ", _this.info);
      _this.$axios
        .put(_this.config.path + "/users/" + _this.info.id, _this.info, {
          headers: {
            Authorization: "Bearer " + this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === true) {
            _this.$message({
              showClose: true,
              message: "修改个人信息成功",
              type: "success",
            });
            _this.config.setCookie(
              res.data.data.token.token,
              res.data.data.token.expired
            );
            _this.config.storageLoginInfo(res.data);
            setTimeout(function () {
              _this.$router.go(0);
            }, 500);
          } else {
            _this.$message({
              showClose: true,
              message: "修改个人信息失败: " + res.data.message,
              type: "error",
            });
          }
        })
        .catch(function (err) {
          _this.$message({
            showClose: true,
            message: "修改个人信息失败: " + err.toString(),
            type: "error",
          });
        });
    },
  },
};
</script>